import { useState } from "react";
import { getClientDomain } from "./useFetchUnits";
import { Announcement, PaginationMeta } from "src/types";
import { useAnnouncementsInfinite } from "./useFetchAnnouncements";
import { logEnvironment } from "@components/lib/utils";
interface UseAnnouncementsProps {
  search?: string;
  prefetchedAnnouncements?: Announcement[]; // Adjust type as needed
}

export interface AnnouncementApiResponseMetadata {
  status: "success" | "error";
  total_announcement: number;
  total_announcement_month: number;
  total_announcement_view: number;
  total_announcement_month_view: number;
  data: Announcement[];
  pagination: PaginationMeta;
}

interface PaginatedResponse {
  pages: Array<[AnnouncementApiResponseMetadata, Announcement[]]>;
  pageParams: number[];
}

export function useAnnouncements({
  search,
  prefetchedAnnouncements,
}: UseAnnouncementsProps) {
  const [sort, setSort] = useState<string | undefined>(undefined);
  logEnvironment("this the fetch announcement componennt");

  const location = getClientDomain("ftech announcements");

  const { data, fetchNextPage, isFetchingNextPage, hasNextPage, isLoading } =
    useAnnouncementsInfinite({ location, sort, search });

  const updatedData = data as unknown as PaginatedResponse;

  // Prefer real data if available, otherwise fall back to prefetched
  const announcements =
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updatedData?.pages?.flatMap(([item, announcements]) => announcements) ??
    prefetchedAnnouncements;

  const showDefault = !isLoading && announcements?.length === 0;

  return {
    sort,
    setSort,
    location,
    data,
    search,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    isLoading,
    announcements,
    showDefault,
  };
}
